import '../apps/bankrate-ga-dataLayer';
import './recirculation';

// Expose to global
window.bankrate = window.bankrate || {};
window.bankrate.meta = require('./meta');
